module.exports = __webpack_public_path__ + "img/22.84feb315.png";